export default {"src":"/_next/static/media/0x04c0599ae5a44757c0af6f9ec3b93da8976c150a.9cba0cca.svg","height":146,"width":146,"blurWidth":0,"blurHeight":0};